(() => {
  'use strict';

  const path = '/pages/sean-flood-live-in-los-angeles';
  const data = {
    title: 'Sean Flood Live! (In Los Angeles)',
    listen: 'https://seanflood.floodeverything.com/sean-flood-live-in-los-angeles-listen',
    youtubeId: 'u9moXRCIto8',
    cover: 'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/19_fbac7e15-3190-433d-9468-0e8e7240bddf.png?v=1787425111',
    frames: [
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/6_9793e5c2-fa17-4d49-8570-1b467438acf4.png?v=1787439296',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.18_498aa3d3-be2f-4286-b141-63ba85ac2f01.png?v=1787439309',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/17_47ba97c7-4868-409b-afd0-73f930082ba4.png?v=1787439413',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/15_7ec1e5b2-e16c-4508-bfaf-44535fdb610c.png?v=1787439431',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.16_33019133-0c4d-4485-8599-5ec8df57b048.png?v=1787439459',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/17_5ca10612-dfcd-4cab-8903-8693f7926a64.png?v=1787439324'
    ],
    credits: [
      'Created by Sean Flood',
      'Written, performed, produced, recorded, mixed, mastered, edited & directed by Sean Flood · Director of Photography: Enzo Laclotte'
    ]
  };

  const hydrate = () => {
    if (window.location.pathname.replace(/\/$/, '') !== path) return;
    const page = document.querySelector('.f-release-page');
    if (!page || page.dataset.seanLiveHydrated) return;
    page.dataset.seanLiveHydrated = 'true';

    const hero = page.querySelector('.f-release-hero');
    const oldCover = hero?.querySelector('.f-release-cover');
    if (oldCover) {
      const cover = document.createElement('a');
      cover.className = 'f-release-cover';
      cover.href = '#watch-film';
      cover.setAttribute('aria-label', `Watch ${data.title} film`);
      cover.innerHTML = `<img src="${data.cover}" alt="${data.title} cover art" loading="eager">`;
      oldCover.replaceWith(cover);
    }

    const actions = page.querySelector('.f-release-actions');
    const listen = actions?.querySelector('.f-release-button--filled');
    if (listen) listen.href = data.listen;
    if (actions && !actions.querySelector('a[href="#watch-film"]')) {
      const watch = document.createElement('a');
      watch.className = 'f-release-button';
      watch.href = '#watch-film';
      watch.textContent = 'Watch Film';
      const back = actions.querySelector('a[href="/pages/flood-sound"]');
      if (back) actions.insertBefore(watch, back);
      else actions.appendChild(watch);
    }

    const navSection = page.querySelector('.f-release-nav')?.closest('.f-release-section');
    if (!navSection) return;

    const watchSection = document.createElement('div');
    watchSection.className = 'f-release-section';
    watchSection.id = 'watch-film';
    watchSection.innerHTML = `<h2 class="f-release-section-title">Watch Film</h2><div class="f-release-video"><iframe src="https://www.youtube.com/embed/${data.youtubeId}?rel=0&modestbranding=1" title="${data.title} by Sean Flood" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`;

    const framesSection = document.createElement('div');
    framesSection.className = 'f-release-section';
    framesSection.innerHTML = `<h2 class="f-release-section-title">Selected Frames</h2><div class="f-release-frames">${data.frames.map((src, i) => `<button type="button" class="f-release-frame" data-release-lightbox-trigger data-index="${i}" aria-label="Expand ${data.title} selected frame ${i + 1}"><img src="${src}" alt="${data.title} selected frame ${i + 1}" loading="lazy"></button>`).join('')}</div><div class="f-release-lightbox" data-release-lightbox hidden role="dialog" aria-modal="true" aria-label="${data.title} selected frame viewer"><button type="button" class="f-release-lightbox__control f-release-lightbox__close" data-release-lightbox-close aria-label="Close image viewer">Close</button><button type="button" class="f-release-lightbox__control f-release-lightbox__arrow" data-release-lightbox-prev aria-label="Previous frame">←</button><div class="f-release-lightbox__stage" data-release-lightbox-stage><img class="f-release-lightbox__image" data-release-lightbox-image src="" alt=""></div><button type="button" class="f-release-lightbox__control f-release-lightbox__arrow" data-release-lightbox-next aria-label="Next frame">→</button></div>`;

    const creditsSection = document.createElement('div');
    creditsSection.className = 'f-release-section';
    creditsSection.innerHTML = `<h2 class="f-release-section-title">Credits</h2><div class="f-release-credits"><p>${data.credits[0]}</p><p>${data.credits[1]}</p></div>`;

    navSection.before(watchSection, framesSection, creditsSection);
    const navLeft = navSection.querySelector('.f-release-nav > div:first-child');
    const navRight = navSection.querySelector('.f-release-nav > div:last-child');
    if (navLeft) navLeft.innerHTML = '';
    if (navRight && !navRight.querySelector('a[href="/pages/flood-sound"]')) navRight.innerHTML = '';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    page.querySelectorAll('a[href="#watch-film"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        watchSection.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#watch-film');
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
  else hydrate();
})();